import React from 'react';
import { useLocationScope } from '../../AppLocation';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { ManageInformationView } from '../ManageInformationView';
import { ManageFrame } from './ManageFrame';

export const AccountInfoView = () => {
    useLocationScope('info', 'overview');

    return <ManageFrame title="Overview">
        <Flexer height="1.5" />
        <ManageInformationView />
    </ManageFrame>;
};
